<div *ngIf="params['utm_source'] === 'external_stories_otd_calling' && (params?.birthdaytime !== '1' || !params.mini_story.match('1'))" class="nudge">
  <div class="text">You just spoke to <strong>{{caller_name}}</strong> and they believe you can save {{fundraiser?.beneficiaryname?.info_1}}. Make your contribution today.</div>
</div>
<div *ngIf="params?.birthdaytime === '1' && params?.mini_story === '1'" class="bdaynudge">
  <div class="text">Hey, <strong>{{caller_name}}</strong> from Ketto has sent you this story. ❤️</div>
</div>
<div class="mini-story-wrapper">
  <div class="title">{{fundraiser?.title}}</div>

  <div class="banner">
    <img [attr.data-src]="getTheaterImg()" appImgFallback [default]="vars.defaultImg" alt="">
  </div>

  <div class="see-more" *ngIf="params?.mini_story !== '2'">
    <button mat-button href="https://www.google.com/" color="primary" (click)="viewMore.emit(false)">
      <span>View Story</span>
      <i class="material-icons">chevron_right</i>
    </button>
  </div>
</div>

<div *ngIf="fundraiser" class="payment-wrapper">
  <app-story-payment [config]="{
      fundraiser: fundraiser, supporters: false, daysLeft: false, paymentHeader: false, position: 26,
      assured: false, header: false, mini_story: true, theme: params?.birthdaytime === '1' && params?.mini_story === '1' ? 'v2':'v1'
    }">
  </app-story-payment>
  <div *ngIf="vars.fundraiser?.is_multi_patient_campaign && vwo.multi_patient_note_AB()" class="multi-patient-info">
    <app-multi-patient-note theme="noPopover" />
  </div>
</div>